import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-scoreboard',
  templateUrl: './scoreboard.component.html',
  styleUrls: ['./scoreboard.component.css']
})
export class ScoreboardComponent {
  @Input() remainingMines!: number; // The number of remaining mines
  @Input() totalMines!: number;    // The total number of mines
  @Input() gameState!: 'playing' | 'won' | 'lost'; // The game state
  @Output() resetGame = new EventEmitter<void>();

  reset() {
    this.resetGame.emit();
  }

  getEmoji(): string {
    switch (this.gameState) {
      case 'won':
        return "url('/assets/icons/Win.PNG')";
      case 'lost':
        return "url('/assets/icons/Lose.PNG')";
      default:
        return "url('/assets/icons/Happy.PNG')";
    }
  }

  formatNumber(num: number): number[] {
    return num.toString().padStart(3, '0').split('').map(Number);
  }
  
  digitMap: { [key: number]: boolean[] } = {
    0: [true, true, true, true, true, true, false],
    1: [false, true, true, false, false, false, false],
    2: [true, true, false, true, true, false, true],
    3: [true, true, true, true, false, false, true],
    4: [false, true, true, false, false, true, true],
    5: [true, false, true, true, false, true, true],
    6: [true, false, true, true, true, true, true],
    7: [true, true, true, false, false, false, false],
    8: [true, true, true, true, true, true, true],
    9: [true, true, true, true, false, true, true]
  };
}
